import { SelectField } from '../../2-component/selectField/selectField';

export const SelectCustomField = () => (
    <SelectField
    label={'Custom Fields'}
    />
);
